import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { media } from 'legacyComponents/styled/styleUtils';

import { Comments as CommentsView } from 'apps/comments/main/index';

export const Comments = observer(({ story, params, hideAction }) => {
  return (
    <CommentSection>
      <CommentsWrapper>
        <CommentsView
          content={story}
          params={params}
          contentType='story'
          hideAction={hideAction}
        />
      </CommentsWrapper>
    </CommentSection>
  );
});

const CommentSection = styled.div`
  width: 100%;
  height: auto;
  padding: 20px 0px;
  background-color: rgb(250, 250, 250);
  border-top: 1px solid rgba(0, 0, 0, 0.0470588);
`;

const CommentsWrapper = styled.div`
  width: 700px;
  margin: 0px auto;
  ${media.s`
    width: 610px;
  `};
  ${media.xs`
    width: calc(100% - 20px);
  `};
`;
